import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { GlobalsService } from '@ex/module/core/services/globals.service';
import { PlatformUserService } from '@ex/module/core/services/platform-user.service';
import { ModuleName } from '@ex/module/shared/enums/ModuleName';
import { TranslatePipe } from '@ex/module/shared/pipes/translate.pipe';
import { DATA_TOKEN, ICDKPortalComponent } from '@ex/module/shared/Theme/services/zen-cdk.service';
import { ZenSnackbarService } from '@ex/module/shared/Theme/services/zen-snackbar.service';
import { Subscription } from 'rxjs';
import { Clipboard } from '@angular/cdk/clipboard';
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit, OnDestroy, ICDKPortalComponent {

  @Output()
  close: EventEmitter<any> = new EventEmitter();

  @Output()
  results: EventEmitter<any> = new EventEmitter();

  subscription = new Subscription();

  hide = true

  form = new FormGroup({
    newPassword: new FormControl("", [Validators.required, Validators.minLength(8)])
  })

  newPassword: string = '';
  userKey: string = '';
  language: string = '';
  ModuleNames = ModuleName
  user: any
  generatedPassword: string = '';

  constructor(@Inject(DATA_TOKEN) data: { user: any, language: string }
    , private platformUserService: PlatformUserService
    , private snackbarService: ZenSnackbarService
    , private globalService: GlobalsService,
    private clipboard: Clipboard
    , private translatePipe: TranslatePipe) {

    this.user = data.user;
    this.userKey = data.user.key;
    this.language = data.language;
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }


  generatePassword(): void {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+~';
    let password = '';
    for (let i = 0; i < 12; i++) {
      password += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    this.generatedPassword = password;
    this.form.get('newPassword')?.setValue(password);
  }

  copyPassword(): void {
    if (this.generatedPassword) {
      this.clipboard.copy(this.generatedPassword);
    }
  }

  ngOnInit(): void {

  }

  closeModal() {
    this.close.emit("close");
  }

  changePassword() {
    const formData = this.form.value;

    if (!this.form.valid) {
      this.snackbarService.error(this.translatePipe.transform("txtChangePasswordformInvalid", this.language, this.ModuleNames.Common));
      return;
    }

    const sub = this.platformUserService.changePassword({
      userKey: this.userKey,
      password: formData.newPassword
    }).subscribe(response => {
      this.snackbarService.success(this.translatePipe.transform("txtPasswordChangedSuccess", this.language, this.ModuleNames.Common));
      this.results.emit(true);
    }, err => {
      this.snackbarService.error(this.translatePipe.transform("txtPasswordChangedFailed", this.language, this.ModuleNames.Common));
      this.form.reset();
    });

    this.subscription.add(sub);

  }

}
